module.exports = __webpack_public_path__ + "459436b58de9f6cf28af9bb77e84d1da.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-0.png
// module id = 1777
// module chunks = 0